import { Box, Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import { styles } from './styles'

export type TypefaceProps = {
    children: ReactNode
}

export const Info = ({ children }: TypefaceProps): React.ReactElement => {
    return (
        <Box sx={styles.info}>
            <Typography>{children}</Typography>
        </Box>
    )
}

export const Title = ({
    children,
    variant = 'h1',
}: TypefaceProps & { variant?: 'h1' | 'h2' | 'h4' | 'h6' }): React.ReactElement => {
    return (
        <Box sx={variant === 'h1' ? styles.titleHeader : undefined}>
            <Typography variant={variant}>{children}</Typography>
        </Box>
    )
}

export const Subtitle = ({ children, variant = 'body1' }: TypefaceProps & { variant?: 'body1' }): React.ReactElement => {
    return (
        <Typography sx={styles.subtitle} variant={variant} component="div">
            {children}
        </Typography>
    )
}
